import script from "./InquiryFlowAppChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryFlowAppChat.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryFlowAppChat.vue?vue&type=style&index=0&id=233088ac&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-233088ac"]])

export default __exports__